import { render, staticRenderFns } from "./InlineBoxData.vue?vue&type=template&id=6829ad44"
import script from "./InlineBoxData.vue?vue&type=script&lang=js"
export * from "./InlineBoxData.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxData.vue?vue&type=style&index=0&id=6829ad44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports